import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";


// ACTA_COMMERCE_AGENDA_DIALOGS_V3
export const MEETING_OUTCOMES = {
  honored: {
    label: "Rendez-vous fait",
    badgeClass:
      "border-[var(--do-success-border)] bg-[var(--do-success-soft)] text-[var(--do-success)]",
    iconClass:
      "bg-[var(--do-success-soft)] text-[var(--do-success)]",
    borderColor:
      "var(--do-success-border)",
  },

  no_show: {
    label: "Rendez-vous non fait",
    badgeClass:
      "border-[var(--do-danger-border)] bg-[var(--do-danger-soft)] text-[var(--do-danger)]",
    iconClass:
      "bg-[var(--do-danger-soft)] text-[var(--do-danger)]",
    borderColor:
      "var(--do-danger-border)",
  },

  // Compatibilité avec les rendez-vous déjà historisés.
  rescheduled: {
    label: "Replanifié",
    badgeClass:
      "border-[var(--do-info-border)] bg-[var(--do-accent-soft)] text-[var(--do-accent)]",
    iconClass:
      "bg-[var(--do-accent-soft)] text-[var(--do-accent)]",
    borderColor:
      "var(--do-info-border)",
  },

  cancelled_by_us: {
    label: "Rendez-vous non fait",
    badgeClass:
      "border-[var(--do-danger-border)] bg-[var(--do-danger-soft)] text-[var(--do-danger)]",
    iconClass:
      "bg-[var(--do-danger-soft)] text-[var(--do-danger)]",
    borderColor:
      "var(--do-danger-border)",
  },

  cancelled_by_prospect: {
    label: "Rendez-vous non fait",
    badgeClass:
      "border-[var(--do-danger-border)] bg-[var(--do-danger-soft)] text-[var(--do-danger)]",
    iconClass:
      "bg-[var(--do-danger-soft)] text-[var(--do-danger)]",
    borderColor:
      "var(--do-danger-border)",
  },

  contact_again: {
    label: "À recontacter",
    badgeClass:
      "border-[var(--do-info-border)] bg-[var(--do-data-violet-soft)] text-[var(--do-data-violet)]",
    iconClass:
      "bg-[var(--do-data-violet-soft)] text-[var(--do-data-violet)]",
    borderColor:
      "var(--do-info-border)",
  },
};


function contactLabel(contact) {
  const fullName = (
    `${contact?.firstName || ""} ` +
    `${contact?.lastName || ""}`
  ).trim();

  if (
    contact?.company &&
    fullName
  ) {
    return (
      `${contact.company} — ` +
      fullName
    );
  }

  return (
    contact?.company ||
    fullName ||
    "Contact"
  );
}


// ACTA_MEETING_SIMPLE_WORKFLOW_V1
export function MeetingOutcomeDialog({
  editor,
  saving,
  contactName,
  meetingLabel,
  reportUrl,
  calendarLinks,
  onOutcome,
  onNotDone,
  onReschedule,
  onDelete,
  onClose,
}) {
  if (!editor) {
    return null;
  }

  const existingMeta =
    MEETING_OUTCOMES[
      editor.resultCode
    ] || null;

  const completed =
    Boolean(editor.existingOutcome);

  return (
    <div
      className="fixed inset-0 z-[130] flex items-center justify-center acta-modal-overlay p-3 sm:p-4"
      role="dialog"
      aria-modal="true"
      data-testid="agenda-meeting-outcome-modal"
      onClick={() => {
        if (!saving) {
          onClose();
        }
      }}
    >
      <div
        onClick={(event) =>
          event.stopPropagation()
        }
        className="acta-modal-surface w-full rounded-3xl bg-[var(--do-bg-solid)] p-4 pb-[calc(1rem+env(safe-area-inset-bottom,0px))] shadow-2xl sm:max-w-lg sm:p-6"
      >
        <div className="flex items-start justify-between gap-4">
          <div className="min-w-0">
            <div className="label-eyebrow">
              Agenda commercial
            </div>

            <h2 className="mt-1 font-heading text-xl font-black text-[var(--do-ink)]">
              Rendez-vous
            </h2>

            <p className="mt-1 text-sm text-[var(--do-muted)]">
              {contactName}
              {meetingLabel
                ? ` — ${meetingLabel}`
                : ""}
            </p>
          </div>

          <button
            type="button"
            disabled={saving}
            onClick={onClose}
            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-[var(--do-border)] text-xl font-black text-[var(--do-muted)] disabled:opacity-50"
            aria-label="Fermer"
          >
            ×
          </button>
        </div>

        {!completed && calendarLinks && (
          <div
            className="mt-5 grid gap-3 sm:grid-cols-2"
            data-testid="agenda-meeting-calendar-actions"
          >
            <a
              href={calendarLinks.google}
              target="_blank"
              rel="noreferrer"
              className="flex min-h-[50px] items-center justify-center rounded-xl bg-[var(--do-accent)] px-5 text-sm font-black text-[var(--do-on-accent)]"
              data-testid="agenda-meeting-google-calendar-existing"
            >
              Google Agenda
            </a>

            <a
              href={calendarLinks.outlook}
              target="_blank"
              rel="noreferrer"
              className="flex min-h-[50px] items-center justify-center rounded-xl border border-[var(--do-border)] bg-[var(--do-bg-solid)] px-5 text-sm font-black text-[var(--do-ink)]"
              data-testid="agenda-meeting-outlook-calendar-existing"
            >
              Outlook Agenda
            </a>
          </div>
        )}

        {completed ? (
          <div className="mt-5 space-y-4">
            <div
              className={`rounded-xl border px-4 py-3 text-sm font-black ${
                existingMeta?.badgeClass ||
                "border-[var(--do-border)] bg-[var(--do-surface-soft)] text-[var(--do-ink)]"
              }`}
              data-testid="agenda-meeting-final-status"
            >
              Statut :{" "}
              {existingMeta?.label ||
                "Rendez-vous traité"}
            </div>

            {editor.resultCode ===
              "honored" &&
              reportUrl && (
              <Link
                to={reportUrl}
                className="flex min-h-[50px] items-center justify-center rounded-xl bg-[var(--do-accent)] px-5 text-sm font-black text-[var(--do-on-accent)]"
                data-testid="agenda-meeting-report-link"
              >
                {editor.action
                  ?.meetingReportNoteId
                  ? "Ouvrir le compte rendu"
                  : "Créer le compte rendu"}
              </Link>
            )}

            <button
              type="button"
              disabled={saving}
              onClick={onDelete}
              className="min-h-[48px] w-full rounded-xl border border-[var(--do-border)] px-5 text-sm font-black text-[var(--do-accent)] disabled:opacity-50"
              data-testid="agenda-meeting-outcome-delete"
            >
              Supprimer le rendez-vous
            </button>
          </div>
        ) : (
          <div className="mt-5 space-y-3">
            <button
              type="button"
              disabled={saving}
              onClick={() =>
                onOutcome("honored")
              }
              className="min-h-[52px] w-full rounded-xl border border-[var(--do-success-border)] bg-[var(--do-success-soft)] px-5 text-sm font-black text-[var(--do-success)] disabled:opacity-50"
              data-testid="agenda-meeting-outcome-honored"
            >
              Rendez-vous fait
            </button>

            <button
              type="button"
              disabled={saving}
              onClick={onNotDone}
              className="min-h-[52px] w-full rounded-xl border border-[var(--do-danger-border)] bg-[var(--do-danger-soft)] px-5 text-sm font-black text-[var(--do-danger)] disabled:opacity-50"
              data-testid="agenda-meeting-outcome-no_show"
            >
              Rendez-vous non fait
            </button>

            <button
              type="button"
              disabled={saving}
              onClick={onReschedule}
              className="min-h-[52px] w-full rounded-xl border border-[var(--do-border)] bg-[var(--do-bg-solid)] px-5 text-sm font-black text-[var(--do-ink)] disabled:opacity-50"
              data-testid="agenda-meeting-reschedule"
            >
              Modifier la date
            </button>

            <button
              type="button"
              disabled={saving}
              onClick={onDelete}
              className="min-h-[48px] w-full rounded-xl border border-[var(--do-border)] px-5 text-sm font-black text-[var(--do-accent)] disabled:opacity-50"
            >
              Supprimer
            </button>
          </div>
        )}
      </div>
    </div>
  );
}


export function MeetingEditorDialog({
  editor,
  saving,
  contacts,
  contactName,
  calendarLinks,
  onChange,
  onSubmit,
  onDelete,
  onClose,
}) {
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    setEditing(
      editor?.source === "new" ||
      Boolean(
        editor?.startEditing
      )
    );
  }, [editor?.source, editor?.action?.nextActionNoteId, editor?.action?.meetingId]);

  if (!editor) {
    return null;
  }

  const isNew = editor.source === "new";

  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center acta-modal-overlay p-3 sm:p-4"
      role="dialog"
      aria-modal="true"
      data-testid="agenda-meeting-editor"
    >
      <form
        onSubmit={onSubmit}
        onClick={(event) =>
          event.stopPropagation()
        }
        className="acta-modal-surface max-h-[94dvh] w-full overflow-y-auto rounded-3xl bg-[var(--do-bg-solid)] p-4 pb-[calc(1rem+env(safe-area-inset-bottom,0px))] shadow-2xl sm:max-w-2xl sm:rounded-3xl sm:p-6"
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="label-eyebrow">
              Agenda
            </div>

            <h2 className="mt-1 font-heading text-xl font-black text-[var(--do-ink)]">
              {isNew
                ? "Nouveau rendez-vous"
                : "Rendez-vous"}
            </h2>

            {editor.source !==
              "new" && (
              <p className="mt-1 text-sm text-[var(--do-muted)]">
                {contactName}
              </p>
            )}
          </div>

          <button
            type="button"
            disabled={saving}
            onClick={onClose}
            className="flex h-11 w-11 items-center justify-center rounded-xl border border-[var(--do-border)] text-xl font-black text-[var(--do-muted)] disabled:opacity-50"
            aria-label="Fermer"
          >
            ×
          </button>
        </div>

        {editing ? (
          <div className="mt-5 grid gap-4 sm:grid-cols-2">
          {editor.source ===
            "new" && (
            <label className="sm:col-span-2">
              <span className="text-xs font-bold text-[var(--do-muted)]">
                Prospect ou client
              </span>

              <select
                value={editor.prospectId}
                onChange={(event) =>
                  onChange({
                    prospectId:
                      event.target.value,
                  })
                }
                className="mt-2 min-h-[48px] w-full rounded-xl border border-[var(--do-border)] bg-[var(--do-bg-solid)] px-4 text-base"
                required
                data-testid="agenda-new-meeting-prospect"
              >
                {contacts.map(
                  (contact) => (
                    <option
                      key={contact.id}
                      value={contact.id}
                    >
                      {contactLabel(
                        contact
                      )}
                    </option>
                  )
                )}
              </select>
            </label>
          )}

          <label>
            <span className="text-xs font-bold text-[var(--do-muted)]">
              Date
            </span>

            <input
              type="date"
              value={editor.date}
              onChange={(event) =>
                onChange({
                  date:
                    event.target.value,
                })
              }
              className="mt-2 min-h-[48px] w-full rounded-xl border border-[var(--do-border)] px-4 text-base"
              required
            />
          </label>

          <label>
            <span className="text-xs font-bold text-[var(--do-muted)]">
              Heure
            </span>

            <input
              type="time"
              value={editor.start}
              onChange={(event) =>
                onChange({
                  start:
                    event.target.value,
                })
              }
              className="mt-2 min-h-[48px] w-full rounded-xl border border-[var(--do-border)] px-4 text-base"
              required
            />
          </label>

          <label>
            <span className="text-xs font-bold text-[var(--do-muted)]">
              Durée
            </span>

            <select
              value={
                editor.durationMinutes
              }
              onChange={(event) =>
                onChange({
                  durationMinutes:
                    event.target.value,
                })
              }
              className="mt-2 min-h-[48px] w-full rounded-xl border border-[var(--do-border)] bg-[var(--do-bg-solid)] px-4 text-base"
            >
              <option value="15">
                15 minutes
              </option>
              <option value="30">
                30 minutes
              </option>
              <option value="45">
                45 minutes
              </option>
              <option value="60">
                1 heure
              </option>
              <option value="90">
                1 h 30
              </option>
              <option value="120">
                2 heures
              </option>
            </select>
          </label>

          <label>
            <span className="text-xs font-bold text-[var(--do-muted)]">
              Type
            </span>

            <select
              value={editor.meetingType}
              onChange={(event) =>
                onChange({
                  meetingType:
                    event.target.value,
                })
              }
              className="mt-2 min-h-[48px] w-full rounded-xl border border-[var(--do-border)] bg-[var(--do-bg-solid)] px-4 text-base"
            >
              <option value="online">
                En ligne
              </option>
              <option value="physical">
                Physique
              </option>
            </select>
          </label>

          <label className="sm:col-span-2">
            <span className="text-xs font-bold text-[var(--do-muted)]">
              Objet
            </span>

            <input
              type="text"
              value={editor.subject}
              onChange={(event) =>
                onChange({
                  subject:
                    event.target.value,
                })
              }
              className="mt-2 min-h-[48px] w-full rounded-xl border border-[var(--do-border)] px-4 text-base"
              required
            />
          </label>

          {editor.meetingType ===
            "physical" && (
            <label className="sm:col-span-2">
              <span className="text-xs font-bold text-[var(--do-muted)]">
                Adresse du rendez-vous
              </span>

              <input
                type="text"
                value={editor.location}
                onChange={(event) =>
                  onChange({
                    location:
                      event.target.value,
                  })
                }
                className="mt-2 min-h-[48px] w-full rounded-xl border border-[var(--do-border)] px-4 text-base"
                data-testid="agenda-meeting-location"
              />
            </label>
          )}

          <label className="sm:col-span-2">
            <span className="text-xs font-bold text-[var(--do-muted)]">
              Description
            </span>

            <textarea
              rows={4}
              value={editor.description}
              onChange={(event) =>
                onChange({
                  description:
                    event.target.value,
                })
              }
              className="mt-2 w-full rounded-xl border border-[var(--do-border)] px-4 py-3 text-base"
            />
          </label>
          </div>
        ) : (
          <div className="mt-5 space-y-4">
            <div className="grid grid-cols-2 gap-3">
              <div className="rounded-xl border border-[var(--do-border)] bg-[var(--do-surface-soft)] px-4 py-3">
                <div className="text-[11px] font-bold text-[var(--do-muted)]">Date</div>
                <div className="mt-1 text-sm font-black text-[var(--do-ink)]">{editor.date || "—"}</div>
              </div>
              <div className="rounded-xl border border-[var(--do-border)] bg-[var(--do-surface-soft)] px-4 py-3">
                <div className="text-[11px] font-bold text-[var(--do-muted)]">Heure</div>
                <div className="mt-1 text-sm font-black text-[var(--do-ink)]">{editor.start || "—"}</div>
              </div>
            </div>

            {Array.isArray(
              editor.action
                ?.meetingRescheduleHistory
            ) &&
              editor.action
                .meetingRescheduleHistory
                .length > 0 && (
              <div
                className="rounded-xl border border-[var(--do-border)] bg-[var(--do-bg-solid)] px-4 py-3"
                data-testid="agenda-meeting-history"
              >
                <div className="text-[11px] font-bold uppercase tracking-[0.08em] text-[var(--do-muted)]">
                  Historique
                </div>

                <div className="mt-2 space-y-1 text-xs text-[var(--do-ink-soft)]">
                  {editor.action
                    .meetingRescheduleHistory
                    .map(
                      (
                        entry,
                        index
                      ) => {
                        const raw =
                          entry
                            ?.scheduledAt;

                        let label = "";

                        if (raw) {
                          const oldDate =
                            new Date(raw);

                          label =
                            Number.isNaN(
                              oldDate
                                .getTime()
                            )
                              ? raw
                              : oldDate
                                  .toLocaleString(
                                    "fr-FR",
                                    {
                                      dateStyle:
                                        "short",
                                      timeStyle:
                                        "short",
                                    }
                                  );
                        } else {
                          label = [
                            entry?.date,
                            entry?.start,
                          ]
                            .filter(
                              Boolean
                            )
                            .join(" à ");
                        }

                        return (
                          <div
                            key={`${label}-${index}`}
                          >
                            Ancien RDV :{" "}
                            {label ||
                              "date inconnue"}
                          </div>
                        );
                      }
                    )}
                </div>
              </div>
            )}

            {calendarLinks && (
              <section
                className="rounded-xl border border-[var(--do-border)] bg-[var(--do-bg-solid)] p-4"
                data-testid="agenda-meeting-calendar-share"
              >
                <div className="text-sm font-black text-[var(--do-ink)]">
                  Ajouter à l’agenda
                </div>

                <div className="mt-3 grid gap-2 sm:grid-cols-2">
                  <a
                    href={calendarLinks.google}
                    target="_blank"
                    rel="noreferrer"
                    className="flex min-h-[50px] items-center justify-center rounded-xl bg-[var(--do-accent)] px-4 text-sm font-black text-[var(--do-on-accent)]"
                    data-testid="agenda-meeting-google-calendar"
                  >
                    Google Agenda
                  </a>

                  <a
                    href={calendarLinks.outlook}
                    target="_blank"
                    rel="noreferrer"
                    className="flex min-h-[50px] items-center justify-center rounded-xl border border-[var(--do-border)] px-4 text-sm font-black text-[var(--do-ink)]"
                    data-testid="agenda-meeting-outlook-calendar"
                  >
                    Outlook Agenda
                  </a>
                </div>
              </section>
            )}

            <div className="rounded-xl border border-[var(--do-border)] bg-[var(--do-surface-soft)] px-4 py-4">
              <div className="text-[11px] font-bold uppercase tracking-[0.08em] text-[var(--do-muted)]">Objet</div>
              <div className="mt-2 text-sm font-black text-[var(--do-ink)]">{editor.subject || "Rendez-vous"}</div>
              {editor.description ? (
                <p className="mt-2 whitespace-pre-wrap text-sm leading-6 text-[var(--do-ink-soft)]">{editor.description}</p>
              ) : null}
              <div className="mt-3 text-xs text-[var(--do-muted)]">
                {editor.meetingType === "physical" ? "Physique" : "En ligne"} · {editor.durationMinutes || 30} min
                {editor.meetingType === "physical" && editor.location ? ` · ${editor.location}` : ""}
              </div>
            </div>
          </div>
        )}

        {editing ? (
          <div className="mt-6 grid gap-3 sm:grid-cols-2">
          <button
            type="submit"
            disabled={saving}
            className="min-h-[52px] rounded-xl bg-[var(--do-accent)] px-5 font-black text-[var(--do-on-accent)] disabled:opacity-50"
            data-testid="agenda-meeting-save"
          >
            {saving
              ? "Enregistrement…"
              : editor.source ===
                  "new"
                ? "Ajouter le rendez-vous"
                : "Enregistrer les modifications"}
          </button>

          {editor.source !==
            "new" && (
            <button
              type="button"
              onClick={onDelete}
              disabled={saving}
              className="min-h-[52px] rounded-xl border border-[var(--do-border)] bg-[var(--do-accent-soft)] px-5 font-black text-[var(--do-accent)] disabled:opacity-50"
              data-testid="agenda-meeting-delete"
            >
              Supprimer le rendez-vous
            </button>
          )}
          </div>
        ) : editor.source ===
          "new_saved" ? (
          <div className="mt-6 grid gap-3 sm:grid-cols-2">
            <button
              type="button"
              disabled={saving}
              onClick={() =>
                setEditing(true)
              }
              className="min-h-[52px] rounded-xl border border-[var(--do-border)] bg-[var(--do-bg-solid)] px-5 font-black text-[var(--do-ink)] disabled:opacity-50"
              data-testid="agenda-meeting-edit"
            >
              Modifier
            </button>

            <button
              type="button"
              disabled={saving}
              onClick={onClose}
              className="min-h-[52px] rounded-xl bg-[var(--do-accent)] px-5 font-black text-[var(--do-on-accent)] disabled:opacity-50"
              data-testid="agenda-meeting-finish"
            >
              Terminer
            </button>
          </div>
        ) : (
          <div className="mt-6 grid gap-3 sm:grid-cols-2">
            <button
              type="button"
              disabled={saving}
              onClick={() =>
                setEditing(true)
              }
              className="min-h-[52px] rounded-xl bg-[var(--do-accent)] px-5 font-black text-[var(--do-on-accent)] disabled:opacity-50"
              data-testid="agenda-meeting-edit"
            >
              Modifier
            </button>

            <button
              type="button"
              onClick={onDelete}
              disabled={saving}
              className="min-h-[52px] rounded-xl border border-[var(--do-border)] bg-[var(--do-accent-soft)] px-5 font-black text-[var(--do-accent)] disabled:opacity-50"
              data-testid="agenda-meeting-delete"
            >
              Supprimer
            </button>
          </div>
        )}

      </form>
    </div>
  );
}
